import { findKey } from 'lodash'

export const genderMap = {
  0: '指定なし',
  1: '男性',
  2: '女性',
}

export function getGenderCodeByStr(genderStr) {
  return parseInt(
    findKey(genderMap, mapStr => mapStr === genderStr),
    10,
  )
}
